import { Breadcrumb, Button, ButtonIcon, DataTable, Dropdown, Filter, Icon, Search, Switcher, TextInput } from "pepsico-ds";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../loader.jsx";
import { useTranslation } from "react-i18next";
import { toast,ToastContainer } from 'react-toastify';
import activeDirectoryService from "./activa-directory.service.js";
import NoDataFound from "../../common/no_data_found.jsx";

const OtherActiveDirectory = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [toasts, setToasts] = useState([]);
  const { t } = useTranslation();
  const [filteredItems, setFilteredItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { state } = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemsPerPage] = useState(10);
  const [searchByType, setSearchByType] = useState({ id: "gpid", label: t('nonArExtension.gpid') });
  const [searchByValue, setSearchByValue] = useState('');
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoading();
  const [selectedUser, setSelectedUser] = useState(null);
  const agGridRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const selectedGPID = useRef('');
  const [searchUserBasedOn, setSearchUserBasedOn] = useState([{ displayText: t("active_directory.system_id"), value: "System ID",id: 2 }])
  const [searchUserMethod, setSearchUserMethod] = useState([{ displayText: t("active_directory.equals"), value: "EQUALS", id: 1 }]);
  const [serachUserValue, setSerachUserValue] = useState("");
  const [showAccounts, setShowAccounts] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [selectedTypeTabIndex, setSelectedTypeTabIndex] = useState(state?.selectedTypeTabIndex || 0);
  const [selectedOwnerTypeTabIndex, setSelectedOwnerTypeTabIndex] = useState(state?.selectedTypeTabIndex || 0);
  const [showOwnerTypeSwitcher, setShowOwnerTypeSwitcher] = useState(false);
  useEffect(()=>{
    if(showOwnerTypeSwitcher){
      if(selectedOwnerTypeTabIndex === 0){
        setFilteredItems([]);
        getOwnerUsers();
        if(selectedTypeTabIndex!==0)setSelectedTypeTabIndex(0)
      }else{
        setFilteredItems([]);
        getOwnerIDXUsers();
        if(selectedTypeTabIndex!==1)setSelectedTypeTabIndex(1)
      }
    }
  }, [selectedOwnerTypeTabIndex])
  useEffect(()=>{
    if(showAccounts){
      if(selectedTypeTabIndex===0){
        setAccounts([]);
        getAccountsData();
        setAccountsColumns([
          { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
          { columnKey: "ownerGpid", header: t("active_directory.owner"), initialSize: 140, cellData: (ctx) => {
                  return <div>
                      {(ctx.row.original?.ownerGpid && ctx.row.original?.ownerName) ? `${ctx.row.original?.ownerGpid} - ${ctx.row.original?.ownerName}` : ctx.row.original?.ownerGpid ? ctx.row.original?.ownerGpid : ctx.row.original?.ownerName ? ctx.row.original?.ownerName : ctx.row.original?.pepAppOwner ? ctx.row.original?.pepAppOwner : ctx.row.original?.reportingManager || null}
                  </div>
              } },
          { columnKey: "system", header: t("active_directory.system"), initialSize: 100 },
          { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
                  return <>{ctx.row.original?.accountType ? <div className="ad-account-type-of-account">
                    {ctx.row.original?.accountType}
                  </div> : null}</>
              } },
          { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150 },
          {
              columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 150, cellData: (ctx) => {
                  return <>{ctx.row.original?.domain ? <div className="ad-account-environment">
                      {ctx.row.original?.domain}
                  </div> : null}</>
              }
          },
          { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
          {
              columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
                  return <>
                      {
                          ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                          <div className="ad-account-status-inactive">
                              {t("active_directory.inactive")}
                          </div> 
                          : 
                          <div className="ad-account-status-active">
                              {t("active_directory.active")}
                          </div>
                      }
                  </>
              }
          }
        ]);
      }else{
        setAccounts([]);
        getIDXAccountsData();
        setAccountsColumns([
          { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
          { columnKey: "ownerGpid", header: t("active_directory.owner"), initialSize: 140, cellData: (ctx) => {
                  return <div>
                      {(ctx.row.original?.ownerGpid && ctx.row.original?.ownerName) ? `${ctx.row.original?.ownerGpid} - ${ctx.row.original?.ownerName}` : ctx.row.original?.ownerGpid ? ctx.row.original?.ownerGpid : ctx.row.original?.ownerName ? ctx.row.original?.ownerName : ctx.row.original?.pepAppOwner ? ctx.row.original?.pepAppOwner : ctx.row.original?.reportingManager || null}
                  </div>
              } },
          { columnKey: "system", header: t("active_directory.system"), initialSize: 100, cellData: (ctx) => <div>IDX</div> },
          { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
                  return <>{ctx.row.original?.accountType ? <div className="ad-account-type-of-account">
                    {ctx.row.original?.accountType}
                  </div> : null}</>
              } },
          { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150, cellData: (ctx) => <div>Non-Production</div> }, // for prod Production
          // {
          //     columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 150, cellData: (ctx) => {
          //         return <>{ctx.row.original?.domain ? <div className="ad-account-environment">
          //             {ctx.row.original?.domain}
          //         </div> : null}</>
          //     }
          // },
          { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
          {
              columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
                  return <>
                      {
                          ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                          <div className="ad-account-status-inactive">
                              {t("active_directory.inactive")}
                          </div> 
                          : 
                          <div className="ad-account-status-active">
                              {t("active_directory.active")}
                          </div>
                      }
                  </>
              }
          }
        ])
      }
    }
  },[selectedTypeTabIndex])
  const [accountsColumns, setAccountsColumns] = useState([
    { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
    { columnKey: "ownerGpid", header: t("active_directory.owner"), initialSize: 140, cellData: (ctx) => {
            return <div>
                {(ctx.row.original?.ownerGpid && ctx.row.original?.ownerName) ? `${ctx.row.original?.ownerGpid} - ${ctx.row.original?.ownerName}` : ctx.row.original?.ownerGpid ? ctx.row.original?.ownerGpid : ctx.row.original?.ownerName ? ctx.row.original?.ownerName : ctx.row.original?.pepAppOwner ? ctx.row.original?.pepAppOwner : ctx.row.original?.reportingManager || null}
            </div>
        } },
    { columnKey: "system", header: t("active_directory.system"), initialSize: 100, ...(selectedTypeTabIndex===1 && {cellData: (ctx) => <div>IDX</div>}) },
    { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
            return <>{ctx.row.original?.accountType ? <div className="ad-account-type-of-account">
              {ctx.row.original?.accountType}
            </div> : null}</>
        } },
    { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150, ...(selectedTypeTabIndex===1 && {cellData: (ctx) => <div>Non-Production</div>})  }, // for prod Production
    ...(selectedTypeTabIndex!==1 ? [{
        columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 150, cellData: (ctx) => {
            return <>{ctx.row.original?.domain ? <div className="ad-account-environment">
                {ctx.row.original?.domain}
            </div> : null}</>
        }
    }] : []),
    { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
    {
        columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
            return <>
                {
                    ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                    <div className="ad-account-status-inactive">
                        {t("active_directory.inactive")}
                    </div> 
                    : 
                    <div className="ad-account-status-active">
                        {t("active_directory.active")}
                    </div>
                }
            </>
        }
    }
  ])
  const [columns, setColumns] = useState([
    { columnKey: "uid", header: "GPID", initialSize: 130 , cellData: (ctx) => {
        return <>
            <input
                type="radio"
                name="row-selection"
                value={ctx.row.original.uid}
                checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.uid)}
                onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                style={{ textAlign: 'center', marginRight: '10px' }}
            />
                {ctx.row.original.uid}
            </>
    }},
    { columnKey: "pepDisplayedFirstName", header: "FIRST NAME", initialSize: 140, showColumnVisibility: true },
    { columnKey: "pepDisplayedLastName", header: "LAST NAME", initialSize: 140, sortable: true },
    { columnKey: "mail", header: "Email", size:200 },
    { columnKey: "pepUserType", header: "ASSOCIATE TYPE", initialSize: 170 },
    { columnKey: "pepDivisionName", header: "DIVISION", initialSize: 120 },
    { columnKey: "pepsubdivision", header: "SUBDIVISION", initialSize: 120 },
    { columnKey: "pepLocName", header: "LOCATION", initialSize: 120, cellClass: "wrap-cell" },
    { columnKey: "pepUserStatus", header: "STATUS", initialSize: 120 },
    { columnKey: "pepRegistered", header: "REGISTERED", initialSize: 120 },
  ]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onRowSelectionChange = (e, user) => {
      e.stopPropagation();
      showSelectButton(user);
      selectedGPID.current = user?.uid;
  };

  const showSelectButton = (data) => {
    setSelectedUser(data);  
    agGridRef.current?.refreshActionsColumn();
  }

  const onClickCancel = () => {
    navigate(-1)
  }

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const getOwnerUsers = async ()=>{
    if(serachUserValue.length!==8){
      toast.error(t("active_directory.gpid_must_be_8_characters_long"),"error");
      return;
    }
    setLoading(true);
    showLoader();
    try{ 
      const payload = {
        gpid: serachUserValue,
        filter: searchUserMethod?.[0]?.value
      }
      const response = await activeDirectoryService?.searchOwner(payload);
      if(response?.userData){
        const data = Object.values(response?.userData)
        if(!showOwnerTypeSwitcher) setShowOwnerTypeSwitcher(true);
        if(data.length){
          showSelectButton(data[0]);
          selectedGPID.current = data[0]?.uid;
          setFilteredItems(data);
        }
      }
      else {
          toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
      }
    }catch (err) {
      setLoading(false);
      hideLoader();
      setError(err.message || "API call failed");
      toast.error(err?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
    } finally {
      setLoading(false);
      hideLoader();
    }
  }

   const getOwnerIDXUsers = async ()=>{
    if(serachUserValue.length!==8){
      toast.error(t("active_directory.gpid_must_be_8_characters_long"),"error");
      return;
    }
    setLoading(true);
    showLoader();
    try{ 
      const payload = {
        gpid: serachUserValue
      }
      const response = await activeDirectoryService?.searchOwnerIDX(payload);
      if(response?.userData){
        const data = Object.values(response?.userData)
        if(data.length){
          if(!showOwnerTypeSwitcher) setShowOwnerTypeSwitcher(true);
          showSelectButton(data[0]);
          selectedGPID.current = data[0]?.uid;
          setFilteredItems(data);
        }
      }
      else {
          toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
      }
    }catch (err) {
      setLoading(false);
      hideLoader();
      setError(err.message || "API call failed");
      toast.error(err?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
    } finally {
      setLoading(false);
      hideLoader();
    }
  }

  const getIDXOwnerAccountsData = async () => {
    setLoading(true);
    showLoader();
    try{
      const payload = {
        gpid: selectedUser?.uid,
        filter: searchUserMethod?.[0]?.value
      }
      const response = await activeDirectoryService?.searchAccts(payload);
      if(response?.accounts){
        if(selectedOwnerTypeTabIndex!==0) {
          setSelectedOwnerTypeTabIndex(0);
          setShowOwnerTypeSwitcher(false);
        }
        setShowAccounts(true);
        setAccounts(response?.accounts);
      }
      else {
          toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
      }
    }catch (err) {
      setLoading(false);
      hideLoader();
      setError(err.message || "API call failed");
      toast.error(err?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
    } finally {
      setLoading(false);
      hideLoader();
    }
  }

  const getIDXAccountsData = async () => {
    if(searchUserBasedOn?.[0]?.id===2 && serachUserValue.length < 5){
      toast.error(t("active_directory.system_id_must_be_greater_than_5_characters"),"error");
      return;
    }
    setLoading(true);
    showLoader();
    try{
      const payload = {}
      if (searchUserBasedOn?.[0]?.id===1) {
        payload.ownerGpid = selectedUser?.uid;
        payload.filter = searchUserMethod?.[0]?.value;
      }
      else {
        payload.fetchAllAccounts= true;
        payload.fetchInactiveAccounts= true;
        payload.systemID = serachUserValue;
        payload.filter = searchUserMethod?.[0]?.value;
      } 
      const response = await activeDirectoryService?.othersAccountsIDX(payload);
      if(response?.accounts){
        if(selectedOwnerTypeTabIndex!==0) {
          setSelectedOwnerTypeTabIndex(0);
          setShowOwnerTypeSwitcher(false);
        }
        setShowAccounts(true);
        setAccounts(response?.accounts);
      }
      else {
          toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
      }
    }catch (err) {
      setLoading(false);
      hideLoader();
      setError(err.message || "API call failed");
      toast.error(err?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
    } finally {
      setLoading(false);
      hideLoader();
    }
  }

   const getAccountsData = async () => {
    if(serachUserValue.length < 5){
      toast.error(t("active_directory.system_id_must_be_greater_than_5_characters"),"error");
      return;
    }
    setLoading(true);
    showLoader();
    try{
      const payload = {
        fetchAllAccounts: true,
        fetchInactiveAccounts: true
      }
      if (searchUserBasedOn?.[0]?.id===1) {
        payload.ownerGpid = selectedUser?.uid;
        payload.ownerName = selectedUser?.cn;
      }
      else {
        payload.systemID = serachUserValue;
        payload.filter = searchUserMethod?.[0]?.value
      } 
      const response = await activeDirectoryService?.othersAccounts(payload);
      if(response?.accounts){
        if(selectedOwnerTypeTabIndex!==0) {
          setSelectedOwnerTypeTabIndex(0);
          setShowOwnerTypeSwitcher(false);
        }
        setShowAccounts(true);
        setAccounts(response?.accounts);
      }
      else {
          toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
      }
    }catch (err) {
      setLoading(false);
      hideLoader();
      setError(err.message || "API call failed");
      toast.error(err?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
    } finally {
      setLoading(false);
      hideLoader();
    }
  }

  const renderDataTable = () => {
    return (
        <>
          {
            loading ? 
            <div style={{minHeight: "35vh"}}></div> 
            :
              <>{ (showAccounts ? accounts.length>0 : filteredItems.length>0) ?
                <DataTable
                    className="datatable single-extension-table other-request-list other-users-profile-search-table"
                    columns={showAccounts ? accountsColumns : columns}
                    data={showAccounts ? accounts : filteredItems}
                    enableSorting={true}
                    stickyHeader={true}
                    pageIndex={0}
                    pageSize={10}
                    searchPlaceholder="Type a search keyword"
                    selection="single"
                    showColumnFilters={false}              
                    showDescription={false}              
                    showSearchOption={false}
                    showTableHeader={false}
                    showTitle={false}
                    showPagination={true}
                    size="large"
                    tableDescription=""
                    tableHeader=""
                    noDataDescriptionText="No data to display "
                />
                : <NoDataFound />
                }
                {
                  showAccounts ? <Button
                    className="ml-auto"
                    size="medium"
                    text={t('RequestGPIDForNonEmployee.cancel_btn_label')}
                    variant="primary"
                    onClick={onClickCancel}
                /> : null
                }
              </>
           }
        </>
    )
  }

  return (
    <div id="other_users_profile_search" style={{marginLeft:"16px"}}>
      <div className={`d-flex align-items-center justify-content-between ${showAccounts ? "mb-2" : ""}`} style={{flexWrap: "wrap"}}>
        <div
            className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : ''} ad-main-heading-container`}
        >
          <Breadcrumb
            homeIcon={{
              icon: "home",
              onClick:()=>{
                navigate("/home")
              }
            }}
            breadcrumbs={[
                {
                    label: t('menu.home')
                },
                {
                  label: <div onClick={()=>{
                    navigate("/active-directory")
                  }}>{t("homePage.active_directory_dashboard")}</div>
                },
                {
                  label: t("active_directory.accounts_owned_by_others"),
                }
            ]}
            className="ad-breadcrumb mb-0"
          />
          <div className="ad-page-header">
              <div className="ad-main-heading">
                  {(showAccounts && selectedGPID?.current) ? `${t("active_directory.accounts_owned_by")} ${selectedGPID?.current}` : t("active_directory.accounts_owned_by_others")}
              </div>

              <div className="ad-main-desc">
                  {showAccounts ? t("active_directory.list_of_accounts_owned_by_others") : t("active_directory.view_others_account_information_and_activity")}
              </div>
          </div>
        </div>{
          showAccounts ? 
          <div className="guest-management-notification others-account-read-only-box d-flex">
              <Icon
                  className=""
                  color="Interaction/Active"
                  icon="lock"
                  label="Label"
                  onClick={function wRe() { }}
                  size="medium"
                  style={{}}
                  type="default"
              />
              <div>
                <div className="heading">{t("active_directory.this_view_is_read_only")}</div>
                <div>{t("active_directory.this_view_is_read_only_sub_text1")}</div>
                <div>{t("active_directory.this_view_is_read_only_sub_text2")}</div>
                <ul>
                  <li>{t("active_directory.this_view_is_read_only_list_text_one1")}<strong>{t("active_directory.this_view_is_read_only_list_text_one2")}</strong>{t("active_directory.this_view_is_read_only_list_text_one3")}</li>
                  <li>
                    <div className="d-flex" style={{gap:".25rem"}}>
                      {t("active_directory.this_view_is_read_only_list_text_two1")}
                      <strong>{t("active_directory.this_view_is_read_only_list_text_two2")}</strong>
                      {/* <span className="myidm-link"> */}
                      <strong>
                        {t("active_directory.myIDM")}
                        {/* <Icon
                          className=""
                          color="Interaction/Active"
                          icon="open_in_new"
                          label="Label"
                          onClick={function wRe() { }}
                          size="medium"
                          style={{}}
                          type="default"
                      /> */}
                    </strong>
                    </div>
                  </li>
                </ul> 
              </div>
          </div>
          : null
        }
      </div>
      {
        showAccounts ? null :
        <div className="bulk-save-container row justify-content-end align-items-center" style={{ marginTop: '20px' }}>
            <div className="extension-edit-actions col-md-6 col-12">
                <button className="extension-cancel-button ml-0" onClick={onClickCancel} >                
                    {t('RequestGPIDForNonEmployee.cancel_btn_label')}
                </button>
                <Button
                    className="ml-3"
                    size="medium"
                    text={t('RequestGPIDForNonEmployee.select_btn_label')}
                    variant="primary"
                    disabled={!selectedUser}
                    onClick={selectedTypeTabIndex===0 ? getAccountsData : getIDXAccountsData}
                />
            </div>
        </div>
      }
      <div className={`card p-4 ${showAccounts ? "" : "handle-sticky-padding-profiles-table"}`} style={{ ...(!showAccounts && {marginTop: "-80px"})}}>
        <div className={`container-fluid px-0 ${showAccounts ? "" : "mb-3"}`}>
          {
            showAccounts ?
            <div className="d-flex align-items-center justify-content-between">
              {/* <div className="d-flex align-items-center mb-2" style={{ gap: "8px" }}>
                  <ButtonIcon
                      className="cursor-default"
                      color="Interaction/Active"
                      icon="account_circle"
                      label="Label"
                      onClick={function wRe() { }}
                      size="medium"
                      style={{}}
                      type="default"
                  />
                  <div className="d-flex flex-column">
                      <div className="ad-table-heading text-left">{t("active_directory.account_information")}</div>
                      <div className="ad-table-desc">{t("active_directory.list_of_accounts_owned_by_others")}</div>
                  </div>
              </div> */}
              <Switcher
                  className="mb-2"
                  items={[
                      {
                          label: t("mypam.ad"),
                      },
                      {
                          label: t("mypam.idx"),
                      },
                  ]}
                  selectedItemIndex={selectedTypeTabIndex}
                  onUpdate={(n)=>{
                      setSelectedTypeTabIndex(n);
                  }}
                  size="medium"
                  style={{}}
                  variant="default"
              />
            </div>
            :
            <div className="request-gpid-main-content-header search-user-header row">
              <div className="col-md-4 align-self-center d-flex justify-content-between">
                  <p className="request-gpid-content-header search-user-heading mb-0">{t("RequestNewAccessForOthers.search_by")}</p>
                  {showOwnerTypeSwitcher ? <Switcher
                    className=""
                    items={[
                        {
                            label: t("mypam.ad"),
                        },
                        {
                            label: t("mypam.idx"),
                        },
                    ]}
                    selectedItemIndex={selectedOwnerTypeTabIndex}
                    onUpdate={(n)=>{
                        selectedGPID.current="";
                        setSelectedUser(null);
                        setSelectedOwnerTypeTabIndex(n);
                    }}
                    size="medium"
                    style={{}}
                    variant="default"
                /> : null}
              </div>
              <div className="col-md-8">
                  <div className="row">
                      <div className="col-md-3 col-7 align-self-center mb-3 mb-md-0">
                          <Dropdown
                              childList={[
                                { displayText: t("active_directory.system_id"), value: "System ID",id: 2 },
                                { displayText: t("active_directory.owner_gpid"), value: "Owner GPID", id: 1 }
                              ]}
                              label=""
                              selectedValue={searchUserBasedOn}
                              placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                              isClearable={false}
                              selection="single"
                              size="medium"
                              className="hide-info-icon"
                              setSelectedValue={(value) => {
                                setSerachUserValue("");
                                if(value?.[0]?.id === 1){
                                  setSearchUserMethod([{ displayText: "Equals", value: "EQUALS", id: 1 }])
                                }
                                setSearchUserBasedOn(value)
                              }}
                              onKeyDown={(e) => e.preventDefault()}
                          />
                      </div>
                      <div className="col-md-3 col-5 align-self-center mb-3 mb-md-0">
                          <Dropdown
                              childList={[
                                  { displayText: t("active_directory.equals"), value: "EQUALS", id: 1 },
                                  { displayText: t("active_directory.contains"), value: "CONTAINS", id: 2 },
                                  { displayText: t("active_directory.starts_with"), value: "STARTS_WITH",id: 3 },
                                  { displayText: t("active_directory.ends_with"), value: "ENDS_WITH", id: 4 },
                              ]?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                              label=""
                              selectedValue={searchUserMethod}
                              disabled={searchUserBasedOn?.[0]?.id===1}
                              placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                              isClearable={false}
                              selection="single"
                              size="medium"
                              className="hide-info-icon"
                              setSelectedValue={(value) => setSearchUserMethod(value)}
                              onKeyDown={(e) => e.preventDefault()}
                          />
                      </div>
                      <div className="col-md-4 col-8 align-self-center mb-3 mb-md-0 other-search">
                          <Search
                              label=""
                              value={serachUserValue}
                              // onChange={(e) => setSerachUserValue(e.target.value)}
                              onUpdate={(e) =>{
                                if(searchUserBasedOn?.[0]?.id===1){
                                  const GPID = e?.replace?.(/[^0-9]/g, "");
                                  setSerachUserValue(GPID);
                                }else{
                                  setSerachUserValue(e);
                                }
                              }}
                              className="input-margin-top-bottom-0"
                              placeholderText={t("RequestGPIDForNonEmployee.search_placeholder")}
                              maxLength={searchUserBasedOn?.[0]?.id===1 ? 8 : 100}
                              icon="none"
                              delay={0}
                              isClearable={serachUserValue.length>0}
                          />
                      </div>
                      <div className="col-md-2 col-4 align-self-center d-flex mb-3 mb-md-0">
                          <button className="search-user-request-button request-button w-auto my-0 flex-grow"
                            style={{maxHeight:"32px"}}
                            disabled={!searchUserBasedOn.length || !serachUserValue.length || !searchUserMethod.length}
                            onClick={() => searchUserBasedOn?.[0]?.id===1 ? selectedOwnerTypeTabIndex===0 ? getOwnerUsers() : getOwnerIDXUsers() : selectedTypeTabIndex===0 ? getAccountsData() : getIDXAccountsData()}
                            >
                              {t("RequestGPIDForNonEmployee.search")}
                          </button>
                      </div>
                  </div>

              </div>
            </div>
          }
        </div>
        {renderDataTable()}
      </div>
      <ToastContainer
        position="bottom-center"
        data={toasts}
        removeToast={removeToast}
      />
    </div>
  );
};

export default OtherActiveDirectory;